var vecchioUfficio = null;
if (window.localStorage) {
    vecchioUfficio = window.localStorage.getItem("ufficioCorrente");
}

if (vecchioUfficio && window.CodiciUfficio.filter(x => x == vecchioUfficio).length > 0) {
    vecchioUfficio = vecchioUfficio;
} else {
    vecchioUfficio = window.CodiciUfficio[0];
}

var initialState = {
    profilo: {
        Nome: window.NomeUtente,
        Cognome: window.CognomeUtente,
        Uffici: window.CodiciUfficio,
        AccountId: window.IdUtente,
        Uffici: window.ServiziUffici
    },
    ufficioSelezionato: vecchioUfficio,
    quesitiDaLeggere: 0,
    messaggiDaLeggere: 0
};

const reducers = (state = initialState, action) => {
    switch (action.type) {

        case "IMPOSTA_UFFICIO_SELEZIONATO": {
            const ufficioCorrente = state.profilo.Uffici.find(x => x.CodiceUfficio == action.ufficioSelezionato) || state.profilo.Uffici[0];
            window.localStorage && window.localStorage.setItem("ufficioCorrente", ufficioCorrente.CodiceUfficio);
            return {
                ...state,
                ufficioSelezionato: ufficioCorrente.CodiceUfficio
            };
        }

        case "IMPOSTA_QUESITI_DALEGGERE":
            return {
                ...state,
                quesitiDaLeggere: action.numero
            };

        case "IMPOSTA_MESSAGGI_DALEGGERE":
            return {
                ...state,
                messaggiDaLeggere: action.numero
            };

        default:
            return state;
    }
};

export default reducers;